// 圆环图配置
export const pieOptionConfig = function (seriesData) {
	let colors = [['#30cfed', '#eee'], ['#8686fa', '#eee'], ['#e057f5', '#eee'], ['#f5576b', '#eee'], ['#e057f5', '#eee']];
	const getSeriesData = () => {
		let series = [];
		for (var i = 0; i < seriesData.length; i++) {
			series[i] = {
				name: seriesData[i].name,
				type: "pie",
				center: seriesData.length >=2 ? seriesData[i].center?seriesData[i].center:[i * 22 + 14 + '%', '50%'] : ['30%', '50%'],     //每个圆环图的位置，动态计算
				radius: seriesData.length >= 2 ?seriesData[i].radius?seriesData[i].radius: [50, 60] : (seriesData[i].type?[0,100]:[80, 100]),     //每个圆环图的大小，动态计算
				avoidLabelOverlap: false,
				label: {
					normal: {
						show: seriesData.length >=2 ? true : false,
						position: 'center',
						color: '#666666',
						fontSize: 14,
						fontWeight: 'bold',
					}
				},
				labelLine: {
					normal: {
						show: false
					}
				},
				itemStyle: {
					normal: seriesData.length >= 2 ? {
						color: colors[i][0],
						shadowColor: colors[i][0]
					} : null,
					emphasis: seriesData.length >=2 ? {
						shadowBlur: 10,
						shadowOffsetX: 0,
						shadowColor: 'rgba(0, 0, 0, 0.5)'
					} : {}
				},
				data: seriesData.length >=2 ? [{
					value: seriesData[i].seriesData[0].percentage,
					name: seriesData[i].seriesData[0].name,
					count: seriesData[i].seriesData[0].value,
					label: {
						formatter:(data) => {
							let val = data.data
							let d = val.count
							let name = val.name
							let percent = val.value
							return seriesData[0].percent?`${percent}%\n${name}`:`${d}条\n${name}`
						}
					}
				}, {
					value: 100 - Number(seriesData[i].seriesData[0].percentage),
					hoverAnimation: false,
					itemStyle: {
						normal: {
							color: colors[i][1]
						},
						emphasis: {
							color: colors[i][1],
							shadowBlur: 0
						}
					},
					label: {
						show: false
					},
					tooltip: {
						show: false
					}
				}] : seriesData[i].seriesData
			};
		}
		return series;
	}
	let OptionConfig = {
		tooltip: {
			trigger: 'item',
			formatter: seriesData.length <2 ? "{b}: {c} ({d}%)" : (data) => {
				let val = data.data
				let c = val.count
				let p = val.value
				let name = val.name
				return `${name} <br/>${name}: ${c} (${p}%)`
			}
		},
		toolbox: seriesData[0].toolbox?{
			feature: {
				saveAsImage: {}
			},
			right:25,
			iconStyle:{
				borderColor:"#409eff"
			},
			emphasis:{
				iconStyle:{
					borderColor:"#409eff",
					textBackgroundColor:"#409eff",
				}
			}
		}:{},
		graphic: seriesData.length <2 ?seriesData[0].graphic?seriesData[0].graphic: [{
			type: 'text',
			left: '27%',
			top: '40%',
			style: {
				text: seriesData[0].total,
				fill: '#66666',
				fontSize: 32,
				fontWeight: 'bold',
				textAlign:"center",
			}
		}, {
			type: 'text',
			left: '24%',
			top: '55%',
			style: {
				text: seriesData[0].text || '',
				fill: '#666666',
				fontSize: 14,
				textAlign:"center",
			}
		}] : null,
		legend: {
			type: 'scroll',
			orient: 'vertical',
			y: 'center',    //延Y轴居中
			right: '8%',
			itemGap: 30,
			itemWidth: 8,
			textStyle: {
				fontSize: 12
			},
			align: 'left',
			data: seriesData[0].legend || [],
			icon: "circle",
			formatter: function (name) {
				var total = 0;
				var target;
				let tip = "";
				let le = name.length
				for (var i = 0, l = seriesData[0].seriesData.length; i < l; i++) {
					total += seriesData[0].seriesData[i].value;
					if (seriesData[0].seriesData[i].name == name) {
						target = seriesData[0].seriesData[i].value;
					}
				}
				// 文字长度以17个字换行展示
				// if(le > 17){   
				// 	let l = Math.ceil(le/17)
				// 	for(let i = 1;i <= l;i++){
				// 		if(i < l){
				// 			tip += name.slice(i*17 - 17,i * 17)+'\n';
				// 		}else if(i === l){
				// 			name = tip + name.slice((l-1)*17,le)
				// 		}
				// 	}
				// }
				let pencent = (target === 0 || total === 0) ? 0:((target / total) * 100).toFixed(2);
				var arr
				seriesData.formatter==='custom'?arr=[
					'{a|' + name + '   ' + target + '}{b|' + '(' + pencent + '%)}'
				]:arr=[
					'{a|' + name  + '}'
				]
				return arr.join('\n')
			},
			textStyle: {
				rich: {
					a: {
						fontSize: 14,
						align: 'left',
						color: "#666666",
						padding: [0, 0, 0, 10]
					},
					b: {
						fontSize: 14,
						color: "#999999",
						align: 'right',
					}
				}
			},
		},
		color: seriesData.length >= 2 ? [] : ['#3aa0ff', '#975fe4', '#36cbcb', '#4dcb73', '#fad337', '#8300d7', '#f2637b', '#ff9f7f', '#e7bcf3', '#9fe6b8', '#9d96f5', '#cbb99d', '#31b573', '#a8d59d', '#e1c81d', '#5ca341', '#7a7700'],
		series: getSeriesData()
	}
	console.log(OptionConfig)
	return OptionConfig;
}
